import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { RatingType } from '../../types';
import {
  buttonItemRender,
  mobileRantingOptions,
  pcRantingOptions,
} from '../../constants/rating';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { ratingPlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import './index.scss';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function RatingSelect({
  onChange,
  defaultKey,
  isMobile,
  defaultValue,
  filterValue,
  lang,
}: RatingType) {
  const { formatMessage } = useIntl();

  const rantingOptions: Array<{
    text: JSX.Element | string;
    value: string;
  }> = useMemo(() => {
    return !isMobile ? pcRantingOptions(formatMessage) : mobileRantingOptions;
  }, [isMobile, formatMessage]);

  const {
    diffClassName,
    selects: selectRating,
    setSelects: setSelectRating,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'reviews_rating',
    options: rantingOptions.map((item) => item.value),
  });
  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();
  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'rating',
      commonBackInfo(
        { reviews_rating: selectRating },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll },
      ),
    );
  }, [selectRating, formatMessage]);

  return (
    <div className={`rating-select-wrapper ${isMobile ? "" : "--pc"} ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        buttonItemRender={(value: any) => buttonItemRender(isMobile ? Number(value) : value, formatMessage)}
        matchButtonWidth={isMobile ? true : false}
        boxClassName={isMobile ? '' : 'rating-select-box'}
        placeholderText={ratingPlaceholder[lang]}
        onClear={() => setSelectRating([])}
        selectOptionsInfo={[selectRating, setSelectRating]}
        options={rantingOptions}
        pointKey={FilterButtonPoint.rating}
      ></CustomSelect>
    </div>
  );
}
